module.exports = __webpack_public_path__ + "img/京东E卡.0254bf65.png";